import { Box, Typography } from "@mui/material";
import { LabelValueForTags } from "components/ui/atoms/LabelValue";
import MultipleObjectChip from "../components/MultipleObjectChip";
import ObjectChip from "../components/ObjectChip";
import { getCommons } from "./fieldConverterHelpers";
import { useCustomModel } from "components/context/CustomProvider";
import { DataGridPro, useGridApiRef } from "@mui/x-data-grid-pro";
import modelConverters from "../table/modelConverters";
import ObjectViewModal from "../generics/ObjectViewModal";
import NiceModal from "@ebay/nice-modal-react";
import ModelInfoButton from "../components/ModelInfoButton";
import { useEffect } from "react";
import CustomSimpleTable from "../table/CustomSimpleTable";

const ListFieldViewOld = ({ field, value }) => {
  const model = useCustomModel(field.child);

  if (model && model.viewField) {
    const Component = model.viewField;
    return <Component field={field} value={value} many={true} />;
  }

  return (
    <LabelValueForTags
      label={field.label}
      sx={{ display: field.hidden ? "none" : "inherit" }}
      Tags={value.map((v, index) => (
        <ObjectChip modelName={field.child} obj={v} />
      ))}
      isMissing={
        value === undefined || value === null || value.toString().trim() === ""
      }
    />
  );
};

export const ListFieldView = ({ field, value }) => {
  const model = useCustomModel(field.child);
  const columns = modelConverters.getColumns(model);
  const initialState = modelConverters.getInitialState(model);

  if (model.viewField)
    return <model.viewField field={field} value={value} many />;

  return (
    <>
      <Typography variant="body2">{field.label}</Typography>
      <Box height={25 * value.length + 45}>
        <CustomSimpleTable
          rows={value}
          columns={columns}
          initialState={initialState}
        />
        <ModelInfoButton
          modelName={field.child}
          variant={"link"}
          label="model"
          sx={{ display: "block", textAlign: "right" }}
        />
      </Box>
    </>
  );
};

export const ListCell = ({ value, colDef }) => {
  return (
    <Box onClick={(e) => e.stopPropagation()}>
      <MultipleObjectChip objs={value} modelName={colDef._meta.field.child} />
    </Box>
  );
};

export const listFieldConverter = ({ field }) => {
  return {
    ...getCommons({ field }),
    type: "string",
    renderCell: ListCell,
    sortable: false,
  };
};
